import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Input,
  Output,
  EventEmitter,
  OnInit,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { SortByParam } from '@shared/models/sortby-param';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'mojo-sort-candidates',
  templateUrl: './sort-candidates.component.html',
  styleUrls: ['./sort-candidates.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SortCandidatesComponent implements OnInit {
  @Input() menuItems: SortByParam[];
  @Input() isNextToFilter = false;
  @Input() currentSortBy = undefined;
  @Output() sortChanged = new EventEmitter<SortByParam>();

  currentSortBy$: BehaviorSubject<string>;

  constructor(private store: Store<{}>, private cdf: ChangeDetectorRef) {}

  ngOnInit() {
    this.currentSortBy$ = new BehaviorSubject(this.currentSortBy || this.menuItems[0].label);
  }

  sortBy(sortParam: SortByParam) {
    this.sortChanged.emit(sortParam);
    this.currentSortBy$.next(sortParam.label);
  }

  menuMarkForCheck() {
    this.cdf.markForCheck();
  }
}
